import { TabContentTranslations } from ".";

export const TAB_CONTENT_EN_US: TabContentTranslations = {
	consolidated: "Competence",
	extract: "Extract",
	revenueSettlement: "Cash Settlement",
	new: "NEW",
	consolidatedTooltip:
		"Indicates the period in which the sale or operation was carried out, regardless of the payment date.",
	revenueSettlementTooltip:
		"Indicates the period in which amounts were effectively paid or received.",
};
